import { appendFile } from "fs/promises"

export const DepotList = {
    'au.alice_springs': 'Alice Springs',
    'au.brisbane': 'Brisbane',
    'au.broome': 'Broome',
    'au.byron_bay': 'Byron Bay',
    'au.melbourne': 'Melbourne',
    'au.perth': 'Perth',
    'au.darwin': 'Darwin',
    'au.cairns': 'Cairns',
    'au.sydney': 'Sydney',
    'au.airlie_beach': 'Airlie Beach',
    'au.gold_coast': 'Gold Coast',
    'au.hobart': 'Hobart',
    'au.adelaide': 'Adelaide',

    'nz.auckland': 'Auckland',
    'nz.christchurch': 'Christchurch',
    'nz.queenstown': 'Queenstown',
} as const
export type DepotKey = keyof typeof DepotList
export type DepotName = typeof DepotList[DepotKey]
export type DepotTable = Partial<Record<keyof typeof DepotList, string|number>>

export function flog(...a:Parameters<typeof fetch>):ReturnType<typeof fetch>{
  const now = Date.now()
  const rid = (now+Math.random()).toString(36)
  const [path, options, ...more] = a
  const log = {
    now,
    type: 'fetch',
    rid,
    options: {...(options??{}), headers:Object.keys(options?.headers??{}).length},
    path,
  }
  return fetch(...a).then(res => {
    res.clone().text().then(response => {
      appendFile('/tmp/fetched.json', JSON.stringify({
        ...log,
        response,
        done: Date.now(),
      })+'\n', 'utf8');
    })
    return res
  })
}